import { render, staticRenderFns } from "./broadcast-failed-enteries.vue?vue&type=template&id=554a9788"
import script from "./broadcast-failed-enteries.vue?vue&type=script&lang=js"
export * from "./broadcast-failed-enteries.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports